import styled from 'styled-components';
import WBNLi from 'images/WBN_li.svg';

export default styled.img`
	content: url(${WBNLi});
	width: 14px;
	height: 14px;
	vertical-align: middle;
`;
